import breadcrumb from "@/lib/breadcrumb";
import i18n from "@/lib/i18n";
import router from "@/lib/router";

export default {
	install() {
		i18n.mergeLocaleMessage("fr", {
			"breadcrumb.test.control": "Test de contrôle"
		});

		breadcrumb.add([
			{
				path: "/test/control",
				name: "database>test.control"
			}
		]);

		router.addRoutes([
			{
				name: "testControl",
				path: "/test/control",
				component: () => import("./vues/Index.vue"),
				props: true,
				meta: {
					secured: true,
					roles: ["DATABASE_ADMINISTRATOR"]
				}
			}
		]);
	}
};